import isNonEmptyString from './is-non-empty-string';

const hasValue = (item: unknown) =>
    item != null &&
    typeof item === 'object' &&
    '_value' in item &&
    isNonEmptyString(item._value);

export default hasValue;
